import { Flex, Typography } from "@nestoca/ui";
import { CIRCLE_PROGRESS_TRACKER_PHASES } from "@shared/constants";
import { useTranslation } from "react-i18next";

import { ActiveModal } from "./circle-progress-tracker";
import { PhaseModal } from "./phase-modal";
import styles from "./tracker-modal.module.scss";

type ModalType = {
  applicationId: number;
  isModalOpen: boolean;
  setActiveModal: (activeModal: ActiveModal) => void;
  phaseNumber: number;
  phase: CIRCLE_PROGRESS_TRACKER_PHASES;
  completePercent: number;
};

export const LenderApprovalModal = ({
  applicationId,
  isModalOpen,
  setActiveModal,
  phaseNumber,
  phase,
  completePercent,
}: ModalType) => {
  const { t } = useTranslation("docs");

  const description = (
    <Flex direction="column" gap={5}>
      <Typography className={styles["modal__text"]}>
        {t("progress.stage.lender_approval.description1")}
      </Typography>
      <Typography className={styles["modal__text"]}>
        {t("progress.stage.lender_approval.description2")}
      </Typography>
      <Typography className={styles["modal__text"]}>
        {t("progress.stage.lender_approval.description3")}
      </Typography>
    </Flex>
  );

  return (
    <PhaseModal
      applicationId={applicationId}
      isModalOpen={isModalOpen}
      setActiveModal={setActiveModal}
      phaseNumber={phaseNumber}
      phase={phase}
      completePercent={completePercent}
      totalCompletePercent={completePercent}
    >
      {description}
    </PhaseModal>
  );
};
